import "./App.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import HomePage from "./Components/HomePage";
import SpecialityDetails from "./Components/Spicializations/SpecilityDetails";
import LoginPage from "./Login/LoginPage";

import TopBar from "./Components/TopBar";
import Footer from "./Components/Footer";
import UserDetails from "./Components/UserLogin/UserDetails";
import "./Components/Components.css";
import ServiceBooking from "./Components/MedicalService/ServiceBooking";
import AppointmentsPage from "./Components/UserLogin/AppointmentPage";
import UserScreen from "./Components/UserLogin/UserScreen";
import UpcomingAppointments from "./Components/UserLogin/UpcomingAppointments";
import ReportsPage from "./Components/UserLogin/Report";
import PatientRecordsPage from "./Components/UserLogin/PatientRecord";
import BillingHistoryPage from "./Components/UserLogin/Billing";
import UploadDocumentsPage from "./Components/UserLogin/DocumentPage";
import ScrollToTop from "./OtherComponents/Scroll";
import BackIcon from "./OtherComponents/Back";
import SpecialPackages from "./Components/SplPakage/SpecialPackages";
// import SpecialPackageDetails from "./Components/SplPakage/SpecialPackageDetails";
// import BookingForm from "./Components/SplPakage/BookingForm";
import SpecialPackageFlow from "./Components/SplPakage/SpecialPackageFlow";
import DoctorCardDetails from "./Components/Spicializations/DoctorCard";
import ChildAppFrame from "./ChildAppFrame";
import AboutTrustDoc from "./Components/pages/AboutTrustDoc";
import ContactUs from "./Components/pages/ContactUs";
import Feedback from "./Components/pages/Feedback";
import Careers from "./Components/pages/Careers";
// import ForgotPassword from "./Login/ForgotPassword";

import { HelmetProvider } from "react-helmet-async";

function AppLayout() {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === "/login";

  return (
    <div className="app-container">
      <ScrollToTop />

      {!hideHeaderFooter && <TopBar />}
      <BackIcon />
      <div className="main-content">
        <div className="main-content-inner">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path={`/speciality/:specialityName`}
              element={<SpecialityDetails />}
            />
            <Route path="/login" element={<LoginPage />} />
            {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
            <Route path="/booking-doc-list" element={<ChildAppFrame />} />

            <Route path="/booking/:doctorId/:specialityId" element={<ChildAppFrame />} />

            <Route path="/service-booking" element={<ServiceBooking />} />
            <Route path="/user-details" element={<UserDetails />} />
            <Route path="/appointments" element={<AppointmentsPage />} />
            <Route
              path="/upcoming-appointments"
              element={<UpcomingAppointments />}
            />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/patient-records" element={<PatientRecordsPage />} />
            <Route path="/billing-history" element={<BillingHistoryPage />} />
            <Route path="/documents" element={<UploadDocumentsPage />} />
            <Route path="/user" element={<UserScreen />} />
            <Route path="/doctor-details/:id" element={<DoctorCardDetails />} />
            <Route path="/special-packages" element={<SpecialPackages />} />
            <Route
              path="/special-packages/:packageId"
              element={<SpecialPackageFlow />}
            />

            <Route path="/about" element={<AboutTrustDoc />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
        </div>
      </div>

      {!hideHeaderFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
